import type { ReactNode } from 'react';

export const symbol_person_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M369-480q-27 0-45.5-20.5T309-548l16-120q8-57 52-94.5T480-800q59 0 103 37.5t52 94.5l16 120q4 27-14.5 47.5T591-480H369Zm-1-60h224l-16-119q-5-35-32.5-58T480-740q-36 0-63.5 23T384-659l-16 119Zm112 0ZM160-220v-34q0-38 19-65t49-41q67-30 128.5-45T480-420q62 0 123 15.5T731-360q31 14 50 41t19 65v34q0 25-17.5 42.5T740-160H220q-25 0-42.5-17.5T160-220Zm60 0h520v-34q0-16-9.5-30.5T707-306q-64-31-117-42.5T480-360q-57 0-111 11.5T252-306q-14 7-23 21.5t-9 30.5v34Zm260 0Z"
		/>
	</svg>
);
